module.exports = __webpack_public_path__ + "img/avatar200.58bfbd8f.png";